/**
 *    @author: Andrew Sheen
 *    @since:  2021-02-24
 */

import { Component, EventEmitter, Output} from '@angular/core';
import { Router } from '@angular/router';
import { ProgressData, ProgressService } from 'src/refresh/service/progress-service';
import { TimerService } from 'src/refresh/service/timer-service';
import { Path, Progress } from '../constant/page-const';
import { InputData } from '../data/input-data';
var show = console.log.bind( console );


@Component({ 
      selector: 'progress-menu',
      templateUrl: './progress_menu.component.html',
      styleUrls: ['./progress_menu.component.less'],
      //encapsulation: ViewEncapsulation.None
})
export class ProgressMenuComponent {

       public status:Object = new Object();  // number-number
       public menu:Array<ProgressData>;

       @Output() menuSelected = new EventEmitter<string>();

       constructor(protected router: Router,
                   protected progress: ProgressService, 
                   protected timerService:TimerService,
                   public data:InputData) {
              this.status  = progress.progressStatus;
              this.menu    = progress.progressMenuMap;
       }
/**
       public onClick(idx:number) {

              if ( this.data.isSubmit ) return;
              
              let url = "";
              switch(idx) {
                    case Progress.Start:  url = Path.Start;  break; 
                    case Progress.Eligibility: url = Path.Setup1;  break; 
                    case Progress.AboutChild: url = Path.AboutTheChildMain;  break; 
                    case Progress.AboutParent: url = Path.AboutTheParentsMain;  break; 
                    case Progress.Review: url = Path.FinalReview;  break; 
                    case Progress.OrderBC: url = Path.BirthCertificate;  break; 
                    case Progress.CCB: url = Path.CCBMain;  break; 
                    case Progress.SIN: url = Path.SINMain;  break; 
                    case Progress.ESR: url = Path.ESRMain;  break; 
              }

              if ( idx <= Progress.Eligibility ) {
                   this.progress.adjustBundles(this.data);
              }

              this.menuSelected.emit();
              this.router.navigate(["/"+url]);  
       }
 */

       public onClick(idx:number) {

            let target:number = 0;
            switch(idx) {
                  case Progress.Start:       target =  1;  break; 
                  case Progress.Eligibility: target =  3;  break; 
                  case Progress.AboutChild:  target =  8;  break; 
                  case Progress.AboutParent: target = 10;  break; 
                  case Progress.Review:      target = 16;  break; 
                  case Progress.OrderBC:     target = 18;  break; 
                  case Progress.CCB:         target = 20;  break; 
                  case Progress.SIN:         target = 21;  break; 
                  case Progress.ESR:         target = 22;  break; 
            }


            if ( this.data.isNextChild && target <= 3 ) return;

            let parentCnt = this.data.eligibility.listedParentCount;

            ///console.log("=====>TARGET",target,InputData.currentPageIdx);
            
            if ( target >= InputData.currentPageIdx ) {
                 this.goForward(target,parentCnt);
                 return; 
            }

            this.timerService.isForwarding = true;

            let backCnt:number = target;
            let CONTACT_ID = 15;


            if ( backCnt <  CONTACT_ID && InputData.currentPageIdx >= CONTACT_ID ) backCnt += (4-parentCnt);
            else
            if ( backCnt >= CONTACT_ID && InputData.currentPageIdx <  CONTACT_ID ) backCnt -= (4-parentCnt);
   
            if ( InputData.currentPageIdx == 25 )
            {
                 let  birthType = Number(this.data.eligibility.birthType);
                 if ( birthType == 1 ||
                      birthType ==  this.data.subject.index ) backCnt--;
            }     
            
            this.menuSelected.emit();

            InputData.moveNext = target;
            
            backCnt -=InputData.currentPageIdx;

            ///console.log("----->backCnt",backCnt);
            window.history.back();
       }

       private goForward(target:number,parentCnt:number) {
             
               let  current = InputData.currentPageIdx; // target > current
               if ( current == target ) return;

               InputData.moveNext = target;

               this.timerService.isForwarding = true;
               current++;

               ////console.log("current",current, current + (4-parentCnt))
               if ( current >= 12 && current <= 14 ) {
                    if ( current + (4-parentCnt) >= 15 ) {
                         current = 15;
                    }
               }

               this.moveNext(current);
       }     

       private moveNext(current:number) {

               ///console.log("**move.next**",current);
               switch(current) {
                     case  2:  this.router.navigate(["/"+Path.BeforeYouBegin]); return;
                     case  3:  this.router.navigate(["/"+Path.Setup1]); return;
                     case  4:  this.router.navigate(["/"+Path.Setup2]); return;
                     case  5:  this.router.navigate(["/"+Path.Setup3]); return;
                     case  6:  this.router.navigate(["/"+Path.Setup4]); return;
                     case  7:  this.router.navigate(["/"+Path.Setup5]); return;
                     case  8:  this.router.navigate(["/"+Path.AboutTheChildMain]); return;
                     case  9:  this.router.navigate(["/"+Path.AboutTheChildScreen2]); return;
                     case 10:  this.router.navigate(["/"+Path.AboutTheParentsMain]); return;
                     case 11:  this.router.navigate(["/"+Path.AboutTheParentsScreen1]); return;
                     case 12:  this.router.navigate(["/"+Path.AboutTheParentsScreen2]); return;
                     case 13:  this.router.navigate(["/"+Path.AboutTheParentsScreen3]); return;
                     case 14:  this.router.navigate(["/"+Path.AboutTheParentsScreen4]); return;

                     case 15:  this.router.navigate(["/"+Path.ContactInfoAndMailingAddress]); return;
                     case 16:  this.router.navigate(["/"+Path.FinalReview]); return;
                     case 17:  this.router.navigate(["/"+Path.Transition1]); return;
                     case 18:  this.router.navigate(["/"+Path.BirthCertificate]); return;
                     case 19:  this.router.navigate(["/"+Path.Transition2]); return;
                     case 20:  this.router.navigate(["/"+Path.CCBMain]); return;
                     case 21:  this.router.navigate(["/"+Path.SINMain]); return;
                     case 22:  this.router.navigate(["/"+Path.ESRMain]); return;
               }

               if ( current >= 12 && current <= 14 ) {
                    let  pCnt = (current-10);
                    if ( pCnt <= this.data.eligibility.listedParentCount ) {
                        this.router.navigate(["/"+Path.AboutTheParentsScreen+pCnt]); return;
                    }
               }
       }

       public keyPress(event:any, idx:number) {
            if ( event.keyCode == 13 ) {
                  this.onClick(idx);
            }
       }

       public tabMenu(){
            if (document.getElementById('progressbar'))
            document.getElementById('progressbar').focus();
            if (document.getElementById('progressbarmobile'))
            document.getElementById('progressbarmobile').focus();
      }

       public stay(event) {
              event.preventDefault();
              event.stopPropagation();
              return false;
       }
}